module.exports = __webpack_public_path__ + "img/mod_1.5c128ba3.jpg";